<div class="overlay-spinner" [ngClass]="{ active: active$ | async }">
  <div style="position: relative; height: 6.25rem; z-index: 0">
    <ngl-spinner [size]="'large'" [variant]="'brand'" alternativeText="Loading"></ngl-spinner>
  </div>
</div>
